export default function InputLabel({ id, label, value, onChange }) {
    return (<div className="inputlabel">
        <label htmlFor={id}>{label}</label>
        <input type="text" id={id} value={value} onChange={onChange}/>
    </div>);
}
